<template >
  <index v-show="show"></index>
</template>

<script>
  import Index from './IndexMain.vue'

  export default {
    name: 'bind-email-box',
    props: {
      'show': {type: Boolean, default: true}
    },
    components: {
      Index
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?5e470398